export default __webpack_public_path__ + "static/media/bang.55c55e79.png";